<template>
  <div class="subject-question layout-content" id="questions">
    <div>
      <div class="title">帮助与常见问题</div>
      <div class="question-wrapper">
        <template v-for="(option, index) in info">
          <dl :key="index" v-if="index < length">
            <dt>{{ option.q }}</dt>
            <p v-if="option.a" v-html="option.a"></p>
            <div class="code" v-if="option.extra">
              <img :src="option.extra" alt="" />
            </div>
            <template v-if="option.desc && option.desc.length">
              <ul>
                <li v-for="(desc, i) in option.desc" :key="i" v-html="desc"></li>
              </ul>
            </template>
          </dl>
        </template>

        <div class="btns-wrap" v-if="this.info.length > 3">
          <div
            class="more"
            @click="length = length == info.length ? 3 : info.length"
          >
            {{ info.length > length ? "展开更多" : "收起" }}
            <Icon code="&#xe604;" :class="[info.length > length ? '' : 'span-rotate']"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import vueTypes from 'vue-types'

import Icon from '../../components/Icon'

export default {
  components: {
    Icon
  },
  props: {
    info: vueTypes.array.def([])
  },
  data () {
    return {
      length: 3
    }
  },
  watch: {
    'info': {
      handler: function (val) {
        this.length = val.length
      },
      immediate: false
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../style/bulma/app.sass';
@import './base.scss';
.subject-question {
  padding-bottom: 50px;
  margin: 0 auto;
  // position: relative;
  // left: -38px;
  color: #353535;
}
.title {
  margin: 0;
  padding-left: 42px;
  @include lineFont(28, 500);
  background: no-repeat url(https://static001.geekbang.org/resource/image/12/af/121d756ca11fe5efabc2c4c71c2cdaaf.png) 0 / auto 29px;

}

.more {
  @include lineFont(18, 500);
  cursor: pointer;

  .iconfont {
    display: inline-block;
    position: relative;
    top: 0px;
    margin-left: -1px;
    font-weight: 600;
    font-size: 20px;
    color: orange;
  }
}

.question-wrapper {
  position: relative;
  padding-top: 21px;
  ::v-deep & strong {
    color: #404040;
  }

  & dl {
    padding: 39px 0 3px;
    border-top: 1px solid #f1f1f1;

    &:first-child {
      border-top: none;
    }
  }

  & dt {
    padding-bottom: 15px;
    @include lineFont(17, 500);
  }

  & p {
    padding-bottom: 9px;
    line-height: 24px;
    @include font(15);
    color: $gray;
  }

  & .code {
    box-sizing: border-box;
    width: 125px;
    height: 125px;
    padding: 2px;
    margin: 7px 0 15px;
    border: 1px solid rgba(241, 241, 241, 1);

    & img {
      width: 100%;
      height: 100%;
    }
  }

  & ul {
    padding-bottom: 5px;
  }

  & li {
    position: relative;
    padding: 0 0 4px 32px;
    line-height: 24px;
    @include font(15);
    color: $gray;

    &:before {
      content: "";
      position: absolute;
      left: 15px;
      top: 9px;
      width: 6px;
      height: 6px;
      background: #01b634;
      border-radius: 50%;
    }
  }

  & .btns-wrap {
    margin-top: 15px;
    color: #FE7F3D;
  }

  & .span-rotate {
    transform: rotate(180deg);
    position: relative;
    top: 3px;
  }
}

@include mobile {
  .subject-question {
    width: auto;
    padding: 0 20px 30px;
    margin: 0 auto;
    left:0
  }

  .title {
    padding-left: 23px;
    background-size: auto 18px;
    font-size: 18px;
  }

  .question-wrapper {
    padding-top: 9px;

    & dl {
      padding: 14px 0 7px;
    }

    & dt {
      padding-bottom: 7px;
      line-height: 24px;
      @include font(15, 500);
    }

    & p {
      padding-bottom: 9px;
      line-height: 20px;
      @include font(14);
    }

    & .code {
      width: 84px;
      height: 84px;
      margin: 4px 0 13px;
    }

    & ul {
      padding-bottom: 12px;
    }

    & li {
      padding: 0 0 7px 24px;
      line-height: 20px;
      @include font(14);

      &:before {
        left: 10px;
        top: 6px;
      }
    }

    & .btns-wrap {
      margin-top: 0;
    }

    & .more {
      display: block;
      padding: 14px 0 0;
      text-align: center;
      @include lineFont(14, 500);
      -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
      color: #FE7F3D;
      & .iconfont {
        display: inline-block;
        top: 0;
        margin-left: 0;
      }

      & .span-rotate {
        transform: rotate(180deg);
        position: relative;
        top: 3px;
      }
    }
  }

}
</style>
